import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "./components/AppShell";
import { LoadingState } from "./components/ui";
import { useAuth } from "./context/AuthContext";
import { OpsProvider } from "./context/OpsContext";
import LoginPage from "./pages/LoginPage";
import { useTranslation } from "react-i18next";

const AppsPage = lazy(() => import("./pages/AppsPage"));
const DashboardPage = lazy(() => import("./pages/DashboardPage"));
const EventsPage = lazy(() => import("./pages/EventsPage"));
const ProductsPage = lazy(() => import("./pages/ProductsPage"));
const SettingsPage = lazy(() => import("./pages/SettingsPage"));
const SubscribersPage = lazy(() => import("./pages/SubscribersPage"));
const SyncPage = lazy(() => import("./pages/SyncPage"));
const TeamPage = lazy(() => import("./pages/TeamPage"));
const TransactionsPage = lazy(() => import("./pages/TransactionsPage"));

export default function App() {
  const { user, loading } = useAuth();
  const { t } = useTranslation();
  if (loading) return <LoadingState label={t("loadingData")} className="min-h-screen" />;
  if (!user) return <LoginPage />;
  return <OpsProvider><AppShell><Suspense fallback={<LoadingState label={t("loadingData")} className="min-h-72" />}><Routes>
    <Route path="/" element={<DashboardPage />} />
    <Route path="/subscribers" element={<SubscribersPage />} />
    <Route path="/transactions" element={<TransactionsPage />} />
    <Route path="/events" element={<EventsPage />} />
    <Route path="/products" element={<ProductsPage />} />
    <Route path="/sync" element={<SyncPage />} />
    <Route path="/apps" element={<AppsPage />} />
    <Route path="/team" element={<TeamPage />} />
    <Route path="/settings" element={<SettingsPage />} />
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes></Suspense></AppShell></OpsProvider>;
}
